import { useEffect, useState } from 'react';

// 通用分页器: 上一页/下一页 + 页码手动输入跳转 (回车或失焦生效).
// totalPages 由调用方按 total/pageSize 算好传入; showEnds 额外显示 首页/末页.
interface PaginationProps {
    page: number;
    totalPages: number;
    onChange: (page: number) => void;
    total?: number; // 传入则在页码后追加 "· 共 N 条"
    showEnds?: boolean;
    buttonClass?: string; // 按钮样式, 默认 btn-ghost
}

export default function Pagination({
    page,
    totalPages,
    onChange,
    total,
    showEnds = false,
    buttonClass = 'btn-ghost',
}: PaginationProps) {
    const [draft, setDraft] = useState(String(page));
    useEffect(() => setDraft(String(page)), [page]);

    const jump = () => {
        const n = parseInt(draft, 10);
        if (!Number.isFinite(n)) {
            setDraft(String(page));
            return;
        }
        const next = Math.min(totalPages, Math.max(1, n));
        setDraft(String(next));
        if (next !== page) onChange(next);
    };

    return (
        <div className="flex items-center gap-2">
            {showEnds && (
                <button
                    type="button"
                    className={buttonClass}
                    disabled={page <= 1}
                    onClick={() => onChange(1)}
                    title="跳到首页"
                >
                    « 首页
                </button>
            )}
            <button
                type="button"
                className={buttonClass}
                disabled={page <= 1}
                onClick={() => onChange(Math.max(1, page - 1))}
            >
                上一页
            </button>
            <span className="flex items-center gap-1 whitespace-nowrap">
                第
                <input
                    className="inp w-12 px-1 py-0.5 text-center"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value.replace(/[^0-9]/g, ''))}
                    onBlur={jump}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            jump();
                        }
                    }}
                    aria-label="页码"
                />
                / {totalPages} 页{total !== undefined && ` · 共 ${total} 条`}
            </span>
            <button
                type="button"
                className={buttonClass}
                disabled={page >= totalPages}
                onClick={() => onChange(page + 1)}
            >
                下一页
            </button>
            {showEnds && (
                <button
                    type="button"
                    className={buttonClass}
                    disabled={page >= totalPages}
                    onClick={() => onChange(totalPages)}
                    title="跳到末页"
                >
                    末页 »
                </button>
            )}
        </div>
    );
}
